<script lang="ts">
  import type { Snippet } from 'svelte';

  let {
    variant = 'default',
    shape = 'pill',
    size = 'md',
    dot = false,
    children,
    class: className = ''
  }: {
    variant?: 'default' | 'accent' | 'success' | 'warning' | 'danger' | 'info' | 'outline';
    shape?: 'pill' | 'square';
    size?: 'sm' | 'md';
    dot?: boolean;
    children: Snippet;
    class?: string;
  } = $props();
</script>

<span class="badge {className}" data-variant={variant} data-shape={shape} data-size={size}>
  {#if dot}<span class="dot" aria-hidden="true"></span>{/if}
  {@render children()}
</span>

<style>
  .badge {
    display: inline-flex;
    align-items: center;
    gap: var(--space-1);
    font-weight: var(--weight-medium);
    line-height: 1;
    white-space: nowrap;
    vertical-align: middle;
  }

  .badge[data-shape='pill'] { border-radius: var(--radius-full); }
  .badge[data-shape='square'] { border-radius: var(--radius-sm); }

  .badge[data-size='sm'] {
    height: 20px;
    padding: 0 var(--space-2);
    font-size: 0.6875rem;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .badge[data-size='md'] {
    height: 24px;
    padding: 0 var(--space-3);
    font-size: var(--text-caption);
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  /* Default: neutro sutil */
  .badge[data-variant='default'] {
    background: var(--color-surface-sunken);
    color: var(--color-text-secondary);
    border: var(--border-width) solid var(--color-border);
  }

  /* Accent: acento suave */
  .badge[data-variant='accent'] {
    background: var(--color-accent-tint);
    color: var(--color-accent);
  }

  /* Semánticos: fondo tint + texto primary + borde-izq 3px color */
  .badge[data-variant='success'] {
    background: var(--color-success-tint);
    color: var(--color-text-primary);
    border-left: 3px solid var(--color-success);
  }
  .badge[data-variant='warning'] {
    background: var(--color-warning-tint);
    color: var(--color-text-primary);
    border-left: 3px solid var(--color-warning);
  }
  .badge[data-variant='danger'] {
    background: var(--color-danger-tint);
    color: var(--color-text-primary);
    border-left: 3px solid var(--color-danger);
  }
  .badge[data-variant='info'] {
    background: var(--color-info-tint);
    color: var(--color-text-primary);
    border-left: 3px solid var(--color-info);
  }

  /* Outline: solo borde */
  .badge[data-variant='outline'] {
    background: transparent;
    color: var(--color-text-secondary);
    border: var(--border-width) solid var(--color-border-strong);
  }

  .dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex: 0 0 auto;
  }

  .badge[data-variant='success'] .dot { background: var(--color-success); }
  .badge[data-variant='warning'] .dot { background: var(--color-warning); }
  .badge[data-variant='danger'] .dot { background: var(--color-danger); }
  .badge[data-variant='info'] .dot { background: var(--color-info); }
  .badge[data-variant='accent'] .dot { background: var(--color-accent); }
  .badge[data-variant='default'] .dot { background: var(--color-text-muted); }
  .badge[data-variant='outline'] .dot { background: var(--color-text-muted); }
</style>